import React from "react";
import styles from "./styles.css";
import H1 from "../h1/component";
import H2 from "../h2/component";

const TermsInfo = () => {
    return (
        <div className="container" styleName={"styles.main"}>
            <H1 text="Terms of Use"/>
            <p styleName={"styles.terms"}> Last updated on February 27, 2020</p>
            <p styleName={"styles.terms"}>
               Please read these terms of use (<strong>“Terms”</strong>) carefully before
               using <a href="https://www.cars24.com/">www.cars24.com</a> or any
               other associated and related websites or mobile site and mobile
               applications (collectively, <strong>“CARS24 Website/Websites”</strong>)
               of CARS24 SERVICES PRIVATE LIMITED, a Company incorporated under the
               Companies Act, 2013 having its Registered Office at 4th Floor,
               Plot No 65, Sector 44, Gurgaon, Haryana-122003 (<strong>“CARS24”</strong>)
               having Company Incorporation Number (CIN) U74999HR2015FTC056386. By using
               any CARS24 Websites, the guest users or registered users of the
               Website (hereinafter referred to as <strong>“You”</strong> or
                <strong> “Your” </strong> or <strong> “Yourself” </strong> or
                <strong> “User” </strong>) signify Your agreement to be bound by
               these Terms (<strong>“Agreement”</strong>).

            </p>
            <p styleName={"styles.terms"}>
            No information provided on this site shall be considered a substitute
            for Your independent investigation. These Terms are collectively an
            electronic record for the purpose of the Information Technology
            Act, 2000 (<strong> “IT Act” </strong>) and the rules made thereunder.
            These Terms do not require any digital or electronic signature. You must
            not modify the paper or digital copies of any materials You have printed of,
             or downloaded from, the CARS24 Websites in any way, and You must not use any
             illustrations, photographs, video or audio sequences or any graphics separately
             from any accompanying text.

            </p>
            <p styleName={"styles.terms"}>
            By using CARS24 Websites, You confirm that You accept these Terms and that
            You agree to comply with them. If You do not agree to these below mentioned
            Terms, You must not access this site, or access CARS24 Websites or any
            of the Services.

            </p>
            <H2 text="Who are we and what do we do?"/>
            <p styleName={"styles.terms"}>

            CARS24 is a company incorporated under the laws of India and is engaged
            in the business of trading in cars and providing services incidental
            and ancillary thereto (hereinafter referred to as <strong> "Services" </strong>).
            We endeavour to make the process of trading in cars an amazing and
            hassle-free experience for our customers. We hereby clarify that the
            Services mentioned on the Website are subject to availability.
            The online valuations of a car provided by the CARS24 are only prima
            facie quotations arrived on the basis of the information provided by
            the users and are subject to change on further inspection of the vehicle.
             CARS24 reserves the right to modify, amend and/or alter the said
             Service(s) based on its sole discretion and no such Services shall
             be deemed to be any offer or acceptance by CARS24 unless the same are
             accepted by CARS24 separately in writing through its authorized
             representatives. For specific price information, terms applicable,
             program and product information, please e-mail us at
                <a href="mailto:support@cariotauto.com"> support@cariotauto.com</a>.
            </p>
            <H2 text="Services"/>
            <p styleName={"styles.terms"}> Instant Online valuation and Vehicle Purchase
            Services</p>
            <p styleName={"styles.terms"}>
            Any valuation generated by the Valuation Tool (an <strong> "Online Valuation" </strong>)
            is based on the information You give to CARS24 about Your vehicle
            (the <strong> "Vehicle" </strong>) and on the following general assumptions
            CARS24 makes about Your Vehicle (the <strong> "Assumptions" </strong>)
            </p>
            <div styleName={"styles.termsList"}>
                <ul>
                    <li>The Registration Certificate is in the name of the seller.</li>
                    <li>It is not an import, i.e. it is a right-hand drive vehicle with
                        a valid Indian registration plate.
                    </li>
                    <li>
                        It is an insured vehicle with a comprehensive third party insurance cover.
                    </li>
                    <li>
                   In the case of a private non-commercial vehicle, it has never been used for
                   private hire, rental, driving tuition, or as a police vehicle.
                    </li>
                    <li>
                   It is in average condition for its age and mileage – damage
                   added by You will be considered above and beyond fair wear and tear.

                    </li>
                    <li>
                   There are no major mechanical faults with the vehicle.
                    </li>
                    <li>
                   It has no damage, including interior and mechanical.

                    </li>
                    <li>
                   It has an engine, which starts and it can idle on its own, i.e. it
                   is not a non-runner.
                    </li>
                    <li>
                   You have two sets of keys for the vehicle.

                    </li>
                    <li>There are no statutory/ regulatory encumbrances with regard to
                        the vehicle.
                    </li>
                    <li>
                       Any other specific assumption mentioned on the CARS24 website from
                       time to time.
                    </li>
                </ul>
            </div>
            <p styleName={"styles.terms"}>
                An instant Online Valuation is not an offer by CARS24 to purchase the vehicle.
                It is simply a tool to enable You to estimate the prima facie value of Your
                vehicle based on the inputs provided by You. The actual sale price of
                the vehicle can only be evaluated and offered after a physical inspection
                of the Vehicle by authorized evaluators of CARS24. CARS24 always carries out a
                physical inspection of the vehicle before it conveys the intent to proceed with
                further transaction for arriving at a final sale price. After You have received an
                instant Online Valuation, You may book an appointment for an inspection at one of
                CARS24’s branches by calling a consultant of CARS24 (an <strong> ‘Appointment’
                </strong>). Physical Inspection of the Vehicle may involve a thorough inspection of
                the Vehicle including all working components and features and which shall
                be the critical factors to arrive at a sale price of the vehicle, which may
                 be offered by CARS24 accordingly. You shall also be required to provide further
                 details including the details of the Vehicle, which shall be done at the time
                 of Appointment and before the carrying out of the physical inspection of
                 the Vehicle.
            </p>
            <p styleName={"styles.terms"}>
            Values and pricing are the opinions of CARS24, and the actual price of a vehicle
            may vary depending on the vehicle’s actual condition and local market factors.
            The range of values is CARS24’s estimate of what a consumer can reasonably
            expect to receive this week based on the style, mileage and registration city
            of the vehicle when they sell it to a dealer. However, every dealer is different
            and values are not guaranteed. This value will likely be less than the value
            assessed by another consumer because the reselling dealer incurs the cost of
            safety inspections, reconditioning, documentation and other costs of doing
            business. CARS24 assumes no responsibility for errors or omissions.
            </p>
            <h2 styleName={"styles.termsHeading"}> Ancillary Services</h2>
            <p styleName={"styles.terms"}>
            CARS24 provides a platform wherein it lists cars of prospective sellers
            and helps prospective buyers by arranging a meeting between the buyer
            and the seller and assists in finalizing the transaction. The aforesaid
            services may further include value-added services like transfer of ownership
            of the vehicle (<strong> “RC Transfer” </strong>), motor insurance, consumer
            finance facility, and warranty.
            </p>
            <H2 text="Seller Agreement"/>
            <p styleName={"styles.terms"}>
            CARS24 gives the seller an offer to buy the car after carrying out an on-site
             inspection at one of its authorized centers. We also provide home inspection
             services at certain locations.
            </p>
            <p styleName={"styles.terms"}>
            Any offer by CARS24 to purchase the car shall only be effective if and when
            the seller signs the CARS24's Seller Agreement after inspection. The Seller
            Agreement will be subject to such terms and conditions as may be agreed between
            the CARS24 and the Seller.
            </p>
            <p styleName={"styles.terms"}>
            After execution of the Seller Agreement, the seller shall hand over the car,
            car keys, registration documents, service history, user manuals, accessories
            and/or such other items as may be agreed between the CARS24 and the seller.
            </p>
            <H2 text="Conflict"/>
            <p styleName={"styles.terms"}>
            If there is any conflict:
            </p>
            <div styleName={"styles.termsList"}>
                <ul>
                    <li>
                    Between the Privacy Policy and any other agreement, the Privacy
                    Policy shall take precedence but only to the extent of the conflict.
                    </li>
                    <li>Between the specific Seller Agreement and any part of these Terms,
                        the Seller Agreement shall take precedence but only to the extent of
                        the conflict.
                    </li>
                    <li>Between these Terms and any other notices, disclaimers or
                        guidelines appearing on the CARS24 Website, these Terms
                        shall take precedence but only to the extent of the conflict.
                    </li>
                </ul>
            </div>
            <H2 text="Electronic Communications" />
            <p styleName={"styles.terms"}>
            You may take note that CARS24 may contact You and send You best offers
            and/or related communications including promotional offers on Your
            given email address and may contact You on Your other contact numbers.
            Therefore, by availing the Services, You hereby provide Your consent
            and allow CARS24 to communicate with You on the given contact information
            and share with You any promotional and ancillary offers.
            </p>
            <H2 text="Eligibility / Authorized Use"/>
            <p styleName={"styles.terms"}>
            If You prefer to avail Services using the CARS24 Websites then You further
            warrant that You have the requisite legal competency/authority to enter
            into a binding legal contract for the said Services. Persons who are
            "incompetent to contract" within the meaning of the Indian Contract Act,
            1872 including minors, un-discharged insolvents etc. are not eligible to
            use CARS24 Websites. CARS24 Websites are not available to persons whose
            membership has been suspended or terminated by CARS24 Websites. If You
            are registering as a business entity, You represent that You have the
            authority to bind the entity to these Terms. If You are below 18 years
            of age, please get Your parent/guardian to read and accept these Terms
            before You access the CARS24 Websites. Also, do not give Your or Your
            parent/guardian’s name, address, phone number or email address without
            their permission. You agree to be financially responsible for all of
            Your use of the Services (as well as for use of Your account by others,
             including without limitation minors living with You). You agree to
             supervise and be responsible for all usage of minors of the Services
             under Your name or account. You also warrant that all information
             supplied by You or members of Your household in using the Services,
             including without limitation Your name, email address, street address,
              telephone number, and that all the information submitted by You is true
              and accurate. Failure to provide accurate information may subject You
              to civil and criminal action.
            </p>
            <H2 text="For Whom"/>
            <p styleName={"styles.terms"}>
            CARS24 Websites are primarily for the use of citizens of India, and
            for the people/ person(s) residing in India. No offer of any nature
             whatsoever, arising out of and/or pertaining to CARS24 Websites is/are
              applicable and/or extended and/or made to any other people/person(s).
              CARS24 Websites are not liable for any use whatsoever made by any others,
               of any information on CARS24 Websites, including, but not restricted to,
                specifications or prices of any of CARS24's Services.

            </p>
            <H2 text="General"/>
            <p styleName={"styles.terms"}>
            You agree that no joint venture, partnership, employment, or agency relationship
            exists between You and CARS24 as a result of these Terms. CARS24's performance
            of this Agreement is subject to existing laws and legal process, and nothing
            contained in these Terms is in derogation of CARS24's right to comply with
            governmental, court and other applicable laws.

            </p>
            <p styleName={"styles.terms"}>
            If any part of these Terms is determined to be invalid or unenforceable
             pursuant to applicable law (including, but not limited to, the warranty
             disclaimers and liability limitations set forth herein), then such invalid or
              unenforceable provision shall be superseded by a provision that most closely
              matches the intent of the original provision, and the remainder of these Terms
              shall continue in effect.

            </p>
            <p styleName={"styles.terms"}>
            You may access and use the CARS24 Website and the Services either as a
            registered User or as a guest User. However, not all sections of the
            CARS24 Websites and Services will be accessible to guest Users.
            </p>
            <H2 text="Your account and registration obligations"/>
            <h2 styleName={"styles.termsHeading"}>Registered users</h2>
            <p styleName={"styles.terms"}>
            CARS24 makes certain sections of the Services available to You through the
            CARS24 Websites only if You have provided CARS24 certain required user
            information and have created an account and have a CARS24 ID through certain
             log-in ID and password ("Account"). You can create Your Account on the Website by
              logging in through Your 1.)mobile number or third party website user ID viz.
              facebook, google, yahoo id etc. or any other user id as permitted on the
              CARS24 Websites and 2.) OTP or password. CARS24 ID and/or other third party
              login identification as provided above are individually and collectively
              referred to the <strong> “Account Information” </strong>. The aforesaid may be
              amended at the sole discretion of CARS24.
            </p>
            <p styleName={"styles.terms"}>
            In the event that You register as a User by creating an Account in order to
             avail the Services provided by the CARS24 Websites, You will be responsible
              for maintaining the confidentiality and security of the Account Information
               and are fully responsible for all activities that occur through Your
               Account. You agree to (a) immediately notify CARS24 of any unauthorized
               use of Your Account Information or any other breach of security, and (b)
               ensure that You exit from Your Account at the end of each session. CARS24
               cannot and will not be liable for any loss or damage arising from Your failure
                to comply with this section. You may be held liable for losses incurred by
                CARS24 or any other User of or visitor to the CARS24 Websites due to authorized
                or unauthorized use of Your Account as a result of Your failure in keeping Your
                Account Information secure and confidential.
            </p>
            <p styleName={"styles.terms"}>
            You shall ensure that the Account Information provided by You in the Website's
            registration form is true, correct, complete, accurate and up-to-date. Use of
            another User's Account Information for availing the Services is expressly prohibited.
            </p>
            <p styleName={"styles.terms"}>
            If You provide any information that is not correct, true, inaccurate, not current
            or incomplete (or becomes not true, inaccurate, not current or incomplete), or
            CARS24 identifies and/or has reasonable grounds to suspect that such information
            is not true, inaccurate, not current or incomplete, CARS24 has the right to suspend
            or terminate Your account and refuse any and all current or future use of
            the Website/ Services (or any portion thereof).
            </p>
            <p styleName={"styles.terms"}>
            In case You prefer to avail and/or are provided access to specific services and/or
             offers then the said services and/or offers shall be subject to the respective
             terms and conditions, notified from time to time at the sole discretion of CARS24.
            </p>
            <h2 styleName={"styles.termsHeading"}>Guest Users</h2>
            <p styleName={"styles.terms"}>
            CARS24 Websites also allows limited access to the Services for unregistered
            Users (also called as 'Guest Users'). Such Users will be able to browse the
            Website and use the Services for the purpose of such limited access. However,
             You will not be provided the access to certain benefits reserved only for
              Registered Users. These benefits may change from time to time at the sole
              discretion of CARS24 without any prior notice. Depending upon whether
               You are a seller or a buyer or another User who otherwise wishes to
                use the Website, and the nature of Services You wish to avail from
                the Website, You may be required to provide certain personal information and
                CARS24 may collect such personal information provided by You. Your provision of,
                 and CARS24's collection, storage, use, disclosure and otherwise dealing of such
                 personal information shall be governed by CARS24's Privacy Policy
            </p>
            <H2 text="Intellectual Property"/>
            <p styleName={"styles.terms"}>
            You cannot modify, copy, distribute, transmit, display, reproduce, publish,
             license, create derivative works from, transfer, or sell any information,
             Services obtained from any CARS24 Websites - directly or indirectly
             in any medium. Neither these materials nor any portion thereof may be
             stored in a computer except for personal and non-commercial use. CARS24
             will not be held liable for any delays, errors or omissions therefrom,
             or in the transmission or delivery of all or any part thereof, or for
              any damages arising from any of the foregoing.
            </p>
            <h2 styleName={"styles.termsHeading"}>Copyrights</h2>
            <p styleName={"styles.terms"}>
            All content included in CARS24 Websites, including but not limited to text,
            graphics, logos, button icons, images, audio clips, video clips, digital
            downloads, data compilations, and software, is/ are the sole property/
            proprietary/intellectual property of CARS24 and protected copyright.
            </p>
            <p styleName={"styles.terms"}>
             You may use the website content for personal and non-commercial purposes
              in accordance with the principles governing intellectual property laws.
              Any other use or modification of the content of the CARS24 Websites
              without the Company’s prior written authorization is prohibited.
            </p>
            <h2 styleName={"styles.termsHeading"}>Trademarks</h2>
            <p styleName={"styles.terms"}>
            The mark ‘CARS24’ and the logo indicated in the CARS24 websites, is the
            sole exclusive trademark of CARS24 or related entities. All graphics,
            logos, page headers, button icons, scripts and service names (collectively
            ‘Trademarks’) present and visible on this site are trademarks of CARS24.
            The Trademarks mark ‘CARS24’ and the logo may not be used in connection with
            any product or service that is not in any manner connected to or provided by
            CARS24 and is likely to cause confusion among customers, or in any manner
            that disparages or discredits CARS24. All other trademarks not owned by
            CARS24 that appear on this site, are the property of their respective
            owners, who may or may not be affiliated with or connected to CARS24.
            </p>
            <H2 text="No unlawful or prohibited use" />
            <p styleName={"styles.terms"}>
            You warrant to CARS24 that You will not use the CARS24 Websites
            for any purpose that is unlawful, illegal or prohibited by these Terms.
             You shall not use the CARS24 Websites in any manner, which could damage,
             disable, overburden, or impair the CARS24 Websites or interfere with any
             other party's use and enjoyment of the CARS24 Websites. You shall not
              obtain or attempt to obtain any materials through any means not
              intentionally made available or provided for through the CARS24
               Websites.
            </p>
            <H2 text="User Comments"/>
            <p styleName={"styles.terms"}>
            The Company does not assume any obligation to monitor the information
            that Users post / may post on the Site. You warrant that any and all
            information, projects, files or other attachments sent to us
            ('User Material') or comments other than personal data, which
             you may transmit to the Company through the Site, does not infringe
             intellectual property rights or any other applicable laws. Such information,
             material or comments, will be treated as non-confidential and non-proprietary.
              By submitting any information or material, you give the Company an unlimited
              and irrevocable license to use, execute, show, modify and transmit such
               information, material or comments, including any underlying idea, concept
                or know-how. The Company reserves the right to use such information,
                in any way in its sole discretion.
            </p>
            <H2 text="Links to third-party website"/>
            <p styleName={"styles.terms"}>
            CARS24 Websites may contain links to other websites ("Linked Sites").
             Linked Sites are not under CARS24's control and CARS24 will not be
             responsible for the contents of any Linked Site, including without
             limitation any link contained in a Linked Site, or any changes or
             updates to a Linked Site. CARS24 is not responsible for any form of
             transmission received from any Linked Site. CARS24 may provide these
             links to You only as a convenience, and the inclusion of any link does
             not imply endorsement by CARS24 of the Linked Site or any association
              with its operators. Always use caution when giving out any personally
              identifiable information about Yourself or Your children in any
              communication service.
            </p>
            <H2 text="The information we collect"/>
            <p styleName={"styles.terms"}>
            These Terms apply to all information collected or submitted on the
             CARS24 websites. On some pages, You can make requests about products/
             services & prices, and register to receive materials and to give us Your
              feedback on our Services. The types of personal information collected at
              these pages may include (but is not limited to):
            </p>
            <div styleName={"styles.termsList"}>
                <ul>
                    <li>Name</li>
                    <li>Address</li>
                    <li>Email Address</li>
                    <li>Phone No.</li>
                    <li>Mobile No.</li>
                    <li>Survey</li>
                    <li>Online Valuation Reference</li>
                    <li>Vehicle Registration Details</li>
                    <li>Online Valuation</li>
                    <li>Vehicle Manufacturer</li>
                    <li>Vehicle Model</li>
                    <li>Vehicle Color</li>
                    <li>Vehicle Transmission</li>
                    <li>Vehicle Engine Size</li>
                    <li>Vehicle Sample Image</li>
                    <li>Vehicle Insurance</li>
                    <li>Odometer reading of the vehicle</li>
                    <li>Number of previous owners</li>
                    <li>Physical condition of vehicle and accident history</li>
                    <li>Financing of vehicle including any Linked Loan and/ or other Lien.</li>
                    <li>Details of involvement of vehicle in court/ investigation proceedings.</li>
                    <li>Any and all other information in respect of the identity and the
                        condition of the vehicle.
                    </li>
                </ul>
            </div>
            <p styleName={"styles.terms"}>
            On some pages, You can submit information about other people. For example, if You
            refer a page to Your friend, You will need to submit the recipient's address.
            In this circumstance, the types of personal information collected may
            include (but is not limited to):
            </p>
            <div styleName={"styles.termsList"}>
                <ul>
                    <li>Name</li>
                    <li>Address</li>
                    <li>Phone Number</li>
                    <li>Email Address</li>
                    <li>Online Valuation Reference</li>
                    <li>Online Valuation</li>
                    <li>Vehicle Manufacturer</li>
                    <li>Vehicle Model</li>
                    <li>Vehicle Color</li>
                    <li>Vehicle Transmission</li>
                    <li>Vehicle Engine Size</li>
                    <li>Vehicle Sample Image</li>
                    <li>Odometer reading of the vehicle</li>
                    <li>Number of previous owners</li>
                    <li>Physical condition of vehicle and accident history</li>
                    <li>Financing of vehicle</li>
                    <li>Details of involvement of vehicle in court/ investigation proceedings</li>
                    <li>Any and all other information in respect of the identity and the
                        condition of the vehicle.
                    </li>
                </ul>
            </div>
            <H2 text="Information Sharing and disclosure"/>
            <p styleName={"styles.terms"}>
            CARS24 will not sell or rent Your personally identifiable information to anyone.
            CARS24  may send personally identifiable information about You with Your consent.
            CARS24 is required to share Your information to provide the Service requested by
            You, CARS24 responds to subpoenas, court orders or legal process. If CARS24 finds
            that Your action on the website violates CARS24 Terms or any of Your usage guidelines
            for specific Services or any laws prevailing in India, CARS24 shall initiate appropriate
            legal proceedings by taking recourse to all remedies available to it in law and as per
            the Terms and other agreements.
            </p>
            <H2 text="Liability disclaimer"/>
            <p styleName={"styles.terms"}>
            The information, Services included in or available through the CARS24 Websites may
            include inaccuracies or typographical errors. Changes are periodically added to
            the information herein. CARS24 may make improvements and/ or changes in the
            CARS24 Websites at any time. CARS24 makes no representations about the
             suitability, reliability, availability, timeliness, and accuracy of the
             information, software, products, services and related graphics contained
             on the CARS24 Websites for any purpose. All such information, software,
             products, services and related graphics are provided "as is" without warranty
             of any kind.CARS24 hereby disclaim all warranties and conditions with
             regard to this information, software, products, services and related graphics,
              including all implied warranties and conditions of merchantability,
              fitness for a particular purpose, title and non-infringement. In no
              event shall CARS24 be liable for any direct, indirect, punitive,
              incidental, special, consequential damages or any damages whatsoever
               including, without limitation, damages for loss of use, data or profits,
               arising out of or in any way connected with the use or performance of the
               CARS24 Websites, with the delay or inability to use the CARS24 Websites or
               related Services, the provision of or failure to provide services, or for
               any information, software, products, services and related graphics obtained
                through the CARS24 Websites, or otherwise arising out of the use of the
                CARS24 Websites, whether based on contract, tort, negligence, strict
                liability or otherwise, even if CARS24 or any of its suppliers has been
                advised of the possibility of damages. If You are dissatisfied with any
                portion of the CARS24 Websites, or with any of these Terms, Your sole and
                exclusive remedy is to discontinue using the CARS24 Websites.

            </p>
            <H2 text="Termination & access restriction"/>
            <p styleName={"styles.terms"}>
            CARS24 reserves the right, in its sole discretion, to terminate Your access
            to any or all CARS24 Websites and the related Services or any portion thereof
            at any time, without any prior notice.
            </p>
            <H2 text="Opting out"/>
            <p styleName={"styles.terms"}>
            You have the right at any time to stop us from contacting You. If You
            want us to stop contacting, at any time, please contact customer care
            services and CARS24 Website will add Your details to our suppression list.
            </p>
            <p styleName={"styles.terms"}>
            To opt-out of email communications, You can click the unsubscribe
            link within the email You have received. If You have any questions or
             difficulties unsubscribing from email or SMS communication, You can
             contact us.
            </p>
            <p styleName={"styles.terms"}>
            Nothing contained in this clause shall apply to persons who have
            entered into an agreement with CARS24 such that it relieves either
             party of their obligations in this clause.
            </p>
            <H2 text="Modifications of these terms of use"/>
            <p styleName={"styles.terms"}>
            CARS24 reserves the right to change the terms, conditions, and notices under
             which CARS24 Websites are offered, including but not limited to the charges
             associated with the use of the CARS24 Websites. You are responsible for
              regularly reviewing these Terms.

            </p>
            <H2 text="Language and display"/>
            <p styleName={"styles.terms"}>
                CARS24 does not intend to nor has displayed and/ or used any
                 language, which hurts the sentiments of any person nor intends to
                 or has displayed anything which would be deemed to be defamatory
                 in nature. If You feel any language or display as derogatory then
                 You may contact us and write to our customer care. Nevertheless,
                 CARS24 does not own any kind of claim of such nature in case any
                 such query is raised against CARS24 Websites, then CARS24 reserves
                 all rights to defend itself against any such claims.
            </p>
            <H2 text="Dispute resolution"/>
            <p styleName={"styles.terms"}>
            You may write to CARS24 for any issues arising out of the usage of CARS24
             Websites on customer care and CARS24 shall make all efforts to support
             You to resolve the same. However, CARS24 does not own any responsibility
              for any such issues and in case of any dispute arising out of the same
               by You against CARS24 then the same shall be referred to an Arbitrational
               Tribunal consisting of a Sole Arbitrator to be appointed by CARS24, whose
               decision shall be final and binding. The venue of arbitration shall be New
                Delhi and language shall be English. By using the CARS24 Websites
                You provide consent for this clause as well.

            </p>
            <H2 text="Governing Laws"/>
            <p styleName={"styles.terms"}>
            This Agreement shall be governed by the laws of India. By using the
            CARS24 Websites, You hereby consent to the exclusive jurisdiction and
            venue of courts in New Delhi, India, irrespective of Your point of access
            to the CARS24 Websites. Use of CARS24 Websites is unauthorized in any
            jurisdiction that does not give effect to all provisions of these Terms,
             including without limitation to this paragraph.
            </p>
        </div>
    );
};

export default TermsInfo;
